import { Link } from "react-router-dom";
import { useConsent } from "../consent/ConsentContext";

export default function Footer() {
  const year = new Date().getFullYear();
  const { openPreferences } = useConsent();

  return (
    <footer id="kontakt" className="container">
      <p>
        © <span>{year}</span> ShowKompass ·{" "}
        <Link to="/privacy">Impressum &amp; Datenschutz</Link> ·{" "}
        <button type="button" onClick={openPreferences} className="footerLinkBtn">
          Cookie-Einstellungen
        </button>{" "}
        · v0.1.12
      </p>
    </footer>
  );
}
